import { useQuery } from '@tanstack/react-query';

import { readShigoAppConfig } from '../../../../lib/config';
import { useShigoSession } from '../../../../lib/useShigoSession';
import { dashboardRangeKey } from '../../../dashboard/hooks';
import type { DashboardDateRange } from '@/components/dashboard/model';
import { createNetworkDashboardClient } from './api';

export const networkDashboardQueryKey = ['admin', 'network-dashboard'] as const;

function useNetworkDashboardClient() {
  const { session } = useShigoSession();
  const config = readShigoAppConfig();
  return {
    client: createNetworkDashboardClient({
      config: { apiBaseUrl: config.apiBaseUrl, networkId: config.networkId },
      accessToken: session?.accessToken ?? '',
    }),
    enabled: Boolean(session?.accessToken),
  };
}

export function useNetworkDashboardQueries(networkId: string, range: DashboardDateRange) {
  const { client, enabled } = useNetworkDashboardClient();
  const rangeKey = dashboardRangeKey(range);
  const overview = useQuery({
    queryKey: [...networkDashboardQueryKey, networkId, 'overview', rangeKey],
    queryFn: () => client.overview(networkId, range),
    enabled: enabled && Boolean(networkId),
  });
  const demandSources = useQuery({
    queryKey: [...networkDashboardQueryKey, networkId, 'demand-sources', rangeKey],
    queryFn: () => client.demandSources(networkId, range),
    enabled: enabled && Boolean(networkId),
  });
  return { overview, demandSources };
}
